<mat-progress-spinner mode="indeterminate" value="40" color="accent"></mat-progress-spinner>

